import styled from 'styled-components';

export const Image = styled.div`
  img{
    width: 100%;
    height: 85%;
  }
`